import { useEffect, useMemo } from "react";

/** Stable object URL for a local File; revokes when the file changes or unmounts. */
export function useObjectUrl(file) {
  const url = useMemo(() => {
    if (!file || !(file instanceof File)) return "";
    return URL.createObjectURL(file);
  }, [file]);

  useEffect(() => {
    if (!url) return undefined;
    return () => URL.revokeObjectURL(url);
  }, [url]);

  return url;
}
